module.exports = __webpack_public_path__ + "media/images/home/icon-instagram-33094f1f90e2b7aa3738bdae15ccc692.svg";